import { render, staticRenderFns } from "./aboutUsAdd.vue?vue&type=template&id=866d50b4&scoped=true"
import script from "./aboutUsAdd.vue?vue&type=script&lang=js"
export * from "./aboutUsAdd.vue?vue&type=script&lang=js"
import style0 from "./aboutUsAdd.vue?vue&type=style&index=0&id=866d50b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866d50b4",
  null
  
)

export default component.exports